import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageConverterPipe } from '../../pipes/image-converter.pipe'; 
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-technologies',
  standalone: true,
  imports: [CommonModule,ImageConverterPipe,TranslateModule],
  templateUrl: './technologies.component.html',
  styleUrls: ['./technologies.component.scss']
})
export class TechnologiesComponent implements OnInit {
  showTechnologies = false;

  logos = [
    { src: 'assets/svg/servicios/sql.svg', alt: 'SQL' },
    { src: 'assets/svg/servicios/aws.svg', alt: 'AWS' },
    { src: 'assets/svg/servicios/django.svg', alt: 'Django' },
    { src: 'assets/svg/servicios/node.svg', alt: 'Node' },
    { src: 'assets/svg/servicios/mongo.svg', alt: 'MongoDB' },
    { src: 'assets/svg/servicios/redis.svg', alt: 'Redis' }
  ];

  duplicatedLogos = [...this.logos, ...this.logos];

  constructor() {}

  ngOnInit(): void {}

  toggleTechnologies(): void {
    this.showTechnologies = !this.showTechnologies;
  }

  trackByLogo(index: number, logo: { src: string, alt: string }): string {
    return logo.src;
  }

  get buttonClasses(): string {
    return this.showTechnologies ? 'bg-[#F2F4FE] text-[#020042]' : 'bg-[#020042] text-[#F2F4FE]';
  }
}
